var _require = require('../containers'),
    isArray = _require.isArray,
    isObject = _require.isObject;

function eq(a, b) {
  return isArray(a) && isArray(b) ? arrayEq(a, b) : isObject(a) && isObject(b) ? objectEq(a, b) : a === b;
}

function arrayEq(a, b) {
  if (a.length != b.length) {
    return false;
  }

  for (var i = 0; i < a.length; i++) {
    if (!eq(a[i], b[i])) {
      return false;
    }
  }

  return true;
}

function objectEq(a, b) {
  for (var key in a) {
    if (!(key in b)) {
      return false;
    }
  }

  for (var _key in b) {
    if (!(_key in a)) {
      return false;
    }
  }

  for (var _key2 in a) {
    if (!eq(a[_key2], b[_key2])) {
      return false;
    }
  }

  return true;
}

module.exports = {
  eq: eq
};